import React from 'react';

const MainScreen = () => {
    return (
        <div className="welcome">
            <div className="main__screen">
                <h1>Andrii Duminskii</h1>
                <h4>Frontend / Full-Stack Developer</h4>
            </div>
        </div>
    );
}

export default MainScreen;
